var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.temLinhas
    ? _c(
        "div",
        { staticClass: "chat-indice-mensagens" },
        [
          _c(
            "v-menu",
            {
              attrs: {
                "open-on-hover": "",
                left: "",
                "offset-x": "",
                "nudge-left": _vm.FOLGA_ATE_A_COLUNA,
                "close-on-content-click": false,
                "close-delay": _vm.ATRASO_PARA_FECHAR,
                "content-class": "ia-fontes-menu",
                "min-width": "220",
                "max-width": "300"
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on
                      var attrs = ref.attrs
                      return [
                        _c(
                          "button",
                          _vm._g(
                            _vm._b(
                              {
                                staticClass: "chat-indice-mensagens__coluna",
                                attrs: {
                                  type: "button",
                                  "aria-label": _vm.rotuloDoGatilho,
                                  "aria-expanded": _vm.aberto ? "true" : "false"
                                },
                                on: { click: _vm.alternar }
                              },
                              "button",
                              attrs,
                              false
                            ),
                            on
                          ),
                          _vm._l(_vm.linhas, function(linha) {
                            return _c("span", {
                              key: linha.id,
                              staticClass: "chat-indice-mensagens__traco",
                              class: {
                                "chat-indice-mensagens__traco--ativo":
                                  linha.ativa
                              },
                              attrs: { "aria-hidden": "true" }
                            })
                          }),
                          0
                        )
                      ]
                    }
                  }
                ],
                null,
                false,
                1756889190
              ),
              model: {
                value: _vm.aberto,
                callback: function($$v) {
                  _vm.aberto = $$v
                },
                expression: "aberto"
              }
            },
            [
              _c("div", { staticClass: "chat-indice-mensagens__painel" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "chat-indice-mensagens__painel-topo ia-texto-selo"
                  },
                  [_vm._v(_vm._s(_vm.titulo))]
                ),
                _c(
                  "ul",
                  { staticClass: "chat-indice-mensagens__lista" },
                  _vm._l(_vm.linhas, function(linha) {
                    return _c("li", { key: linha.id }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "chat-indice-mensagens__item ia-texto-auxiliar text-truncate",
                          class: {
                            "chat-indice-mensagens__item--ativo": linha.ativa
                          },
                          attrs: {
                            type: "button",
                            title: linha.texto,
                            "aria-current": linha.ativa ? "true" : null
                          },
                          on: {
                            click: function($event) {
                              return _vm.rolar(linha.id)
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(linha.texto) + " ")]
                      )
                    ])
                  }),
                  0
                )
              ])
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }